import React from 'react';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  href?: string;
  className?: string;
  fullWidth?: boolean;
}
export function CTAButton({
  children,
  onClick,
  href,
  className = '',
  fullWidth = false
}: CTAButtonProps) {
  const baseClasses = `
    group relative flex items-center justify-center gap-2
    bg-[#2d5016] hover:bg-[#1e3a0f] text-white
    font-bold text-lg py-4 px-8 rounded-lg shadow-lg
    transition-all duration-200 transform hover:-translate-y-0.5
    ${fullWidth ? 'w-full' : 'w-auto'}
    ${className}
  `;
  if (href) {
    return <a href={href} target="_blank" rel="noopener noreferrer" className={baseClasses} data-id="element-52">
        <span data-id="element-53">{children}</span>
        <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-54" />
      </a>;
  }
  return <button onClick={onClick} className={baseClasses} data-id="element-55">
      <span data-id="element-56">{children}</span>
      <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-57" />
    </button>;
}